module.exports = __webpack_public_path__ + "img/w38b.3dd93709.jpg";